import React, { useEffect, useState } from "react";
import { List, Modal, Popconfirm, Skeleton } from "antd";
import { useLazyGetWorkOrderAssetFollowUpWorkOrdersQuery } from "../../store/services/api/work-order-api";
import {humanizeEnum} from "../../utils/humanizers";
import { WorkOrderType } from "../../store/data/entities/work-order";
import { WorkOrderStatus } from "../../store/data/entities/work-order";
import { Button } from "antd";
import {useNavigation} from "@react-navigation/native";



interface WorkOrderAssetFollowUpWorkOrdersModalProps {
  workOrderId: string;
  triggerContent: React.ReactNode;
}

export default function WorkOrderAssetFollowUpWorkOrdersModal({
  workOrderId,
  triggerContent,
}: WorkOrderAssetFollowUpWorkOrdersModalProps) {
  const [open, setOpen] = useState(false);
  const [getFollowUpWorkOrders, { data, isFetching }] =
    useLazyGetWorkOrderAssetFollowUpWorkOrdersQuery();

 const navigation = useNavigation<any>();
  useEffect(() => {
    if (open) {
      getFollowUpWorkOrders({workOrderId});
    }
  }, [open, workOrderId, getFollowUpWorkOrders]);


  const navigateToEdit = (id: string) => navigation.replace('recordView', { id});

  return (
    <>
      <span
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
        style={{ cursor: "pointer", color: "#1677ff" }}
      >
        {triggerContent}
      </span>

      <Modal
        centered
        title="Follow-Up Work Order"
        open={open}
        onCancel={() => setOpen(false)}
        onOk={() => setOpen(false)}
      >
        <Skeleton loading={isFetching} active>
          <div
            style={{
              display: "flex",
              fontWeight: 600,
              borderBottom: "1px solid #f0f0f0",
              padding: "8px 16px",
            }}
          >
            <div style={{ flex: 2 }}>Work Order Reference</div>
            <div style={{ flex: 2 }}>Type</div>
            <div style={{ flex: 2 }}>Status</div>
            <div style={{ flex: 2 }}>Edit Work Order</div>
          </div>

          <List
            style={{ maxHeight: "50dvh", overflowY: "auto" }}
            dataSource={data?.list || []}
            renderItem={(item) => (
              <List.Item key={item.id} style={{ padding: "8px 16px" }}>
                <div style={{ flex: 2 }}>{item.reference}</div>
                <div style={{ flex: 2 }}>{humanizeEnum(WorkOrderType[item.type])}</div>
                <div style={{ flex: 2 }}>{humanizeEnum(WorkOrderStatus[item.status])}</div>
                <div style={{ flex: 2, textAlign: "right" }}>
                  <Popconfirm
                    title="Are you sure you want to navigate to this work order?"
                    onConfirm={() => navigateToEdit(item.id)}
                    >
                      <Button
                        type="link"
                      >
                        Edit Work Order
                      </Button>

                  </Popconfirm>
                  
                </div>
              </List.Item>
            )}
          />
        </Skeleton>
      </Modal>
    </>
  );
}
